import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { NotificationMessages } from '../../Models/Notifications/NotifiyMessages';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';


@Component({
  selector: 'app-Notifications',
  templateUrl: './Notifications.component.html',
  styleUrls: ['./Notifications.component.css'],standalone:false
})
export class NotificationsComponent extends BaseComponent implements OnInit {
 loading:boolean=false;
 userId:string
 latestTimestamp!: string;
 notifications:NotificationMessages[]=[]
 userRole!:string
 constructor
  (
    private messageService:MessageService,
    private auth:AuthService,
    private api:BaseApiService,
  ) {
    super();
    this.userId   =this.auth.getUID();
    this.userRole =this.auth.getRoles().toString();

  }

  GetNotifications(userId:string){
    this.loading=true;
    this.api.read(`Profile_Service/Notifications?userid=${userId}&type=Alert`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
    (
      {
        next:(response)=>{
          this.notifications   = response;
          this.latestTimestamp = this.findLatestTimestamp();
          this.loading         = false;
        },
        error:(
          error
        )=>{
  
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    
    )
  }
  ngOnInit() {
    this.GetNotifications(this.userId);
  }


  private findLatestTimestamp(): string {
    let latestTimestamp = '';
    for (const notification of this.notifications) {
      if (!latestTimestamp || new Date(notification.timestamp) > new Date(latestTimestamp)) {
        latestTimestamp = notification.timestamp;
      }
    }
    return latestTimestamp;
  }
}
